import {EventTracking} from 'utils/amplitude'
import {MoneyFormat} from 'utils/money_format'
import {User} from 'utils/user'

export class PaymentCalculator

  constructor: ->
    @holdingInput = document.querySelector('input#holding')
    @holdingInput.addEventListener 'keyup', (e) => 
      @submitCalculatePayment(e) if e.keyCode is 13
    @holdingInput.addEventListener 'focus', (e) => @holdingInput.value = ""

    form = document.querySelector('.holding-calc form')
    form.addEventListener 'submit', (e) => @submitCalculatePayment(e)

    document.querySelector('.calculate-payment-button').addEventListener 'click', (e) => @submitCalculatePayment(e)
    @setNotificationQuantity()

  submitCalculatePayment: (e) ->
    e.preventDefault()
    EventTracking.track 'CalculateDividendPayment', @eventTrackingData()
    @holdingInput.blur()
    @calculatePayment()

  eventTrackingData: ->
    data = {
      title: document.querySelector('h1').innerText,
      quantity: @holdingInput.value,
      dividend_declared: @valuesDiv().dataset['prevAmount']
    }

  setNotificationQuantity: ->
    qty = User.notificationCount(document.querySelector('h1').dataset.id)
    if qty
      @holdingInput.value = qty
      @calculatePayment()

  calculatePayment: ->
    qty = parseInt(@holdingInput.value)
    qty = 1 if isNaN(qty) or qty < 1
    qty = 1000000000 if qty > 1000000000
    @holdingInput.value = qty
    @setPaymentCalculation qty, 'next'
    @setPaymentCalculation qty, 'prev'

  setPaymentCalculation: (qty, div_class) ->
    values = @valuesDiv()
    amount = values.dataset["#{div_class}Amount"]
    return unless amount
    payment = @formatMoney(qty, amount, values.dataset["#{div_class}Currency"])
    if local_amount = values.dataset["#{div_class}LocalAmount"]
      local_currency = values.dataset["#{div_class}LocalCurrency"]
      payment = "#{@formatMoney(qty, local_amount, local_currency)} (#{payment})"
    document.querySelector(".#{div_class}.your-payment").innerText = payment

  formatMoney: (qty, amount, currency) ->
    total = qty * amount / 100
    digits = if total > 1000 then 0 else 2
    MoneyFormat.format(total, currency, digits)

  valuesDiv: -> document.querySelector('.holding-calc')